import cn from 'classnames';
import {FormEvent, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import FloatingSearchBox from '../../../components/mazraeKit/floatingSearchBox';
import {useAuth} from '../../../context/authContext';
import useGetAddressByLatLngSearch from '../../../services/hookService/getAddressByLatLngSearch/useGetAddressByLatLngSearch';
import {RootState} from '../../../store/redux';
import {addAddress} from '../../../store/redux/myStoreSelectedLocation';
import {getLatLng} from '../../../utilities/helper/getLatLng';
import LocationalCustomMap from '../locationalCustomMap';
import {getStoreName} from '../myStore/contants';

interface ILatLng {
  lat: string;
  lng: string;
}

const MyStoreAddLocationByMap = () => {
  const navigate = useNavigate();
  const selectLocation = useSelector(
    (state: RootState) => state.myStoreSelectedLocation,
  );

  const {state: stateAll} = useLocation();

  const state = useSelector((state: RootState) => state.registerStore);

  const {user} = useAuth() as IAuthContext;

  const farmerProfile = user?.profile?.farmer_profile;
  const supplierProfile = user?.profile?.supplier_profile;

  const dispatch = useDispatch();

  const [latlng, setLatLng] = useState<ILatLng>({
    lng: farmerProfile
      ? farmerProfile?.latlong?.[1]
      : (supplierProfile?.latlong?.[1] as string),
    lat: farmerProfile
      ? farmerProfile?.latlong?.[0]
      : (supplierProfile?.latlong?.[0] as string),
  });
  useEffect(() => {
    if (supplierProfile && supplierProfile?.latlong) {
      setLatLng({
        lng: supplierProfile?.latlong?.[1] as string,
        lat: supplierProfile?.latlong?.[0] as string,
      });
    } else if (farmerProfile && farmerProfile?.latlong) {
      setLatLng({
        lng: farmerProfile?.latlong?.[1] as string,
        lat: farmerProfile?.latlong?.[0] as string,
      });
    }
  }, [supplierProfile?.latlong, farmerProfile?.latlong]);

  useEffect(() => {
    const locationCoords = getLatLng(selectLocation?.location as string);
    if (locationCoords?.length === 2) {
      const [lngNum, latNum] = locationCoords.map(Number);
      if (!isNaN(latNum) && !isNaN(lngNum)) {
        setLatLng({lat: latNum.toString(), lng: lngNum.toString()});
      }
    }
  }, [selectLocation]);

  const {address, isLoading} = useGetAddressByLatLngSearch(
    latlng.lng,
    latlng.lat,
  );

  const [inputValue, setInputValue] = useState<string>(
    address?.city?.name as string,
  );

  useEffect(() => {
    setInputValue(address?.city?.name as string);
  }, [address]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    navigate('/registering-searching-location', {
      state: {
        searchBarAddress: e.target.value,
        type: stateAll?.type,
        store_guid: stateAll?.store_guid,
        lab_guid: stateAll?.lab_guid,
      },
    });
  };

  useEffect(() => {
    setInputValue(selectLocation?.name || '');
  }, [selectLocation?.name]);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(
      addAddress({
        id: address?.city?.id as number,
        location: address?.city?.location as string,
        name: address?.city.name,
        state_id: address?.city?.state_id as number,
      }),
    );

    if (stateAll?.store_guid) {
      navigate(
        `/edit-register-store/${stateAll?.type}/${stateAll.store_guid}`,
        {
          state: {tab: 3},
        },
      );
    } else if (stateAll?.lab_guid) {
      navigate(`/edit-register-store/${stateAll?.type}/${stateAll.lab_guid}`, {
        state: {tab: 4},
      });
    } else if (state?.selectedInput?.id === 2) {
      navigate('/register-lab', {
        state: {tab: 4},
      });
    } else {
      navigate(`/register-store/${getStoreName(state.selectedInput?.code!)}`, {
        state: {tab: 3, scrollToInput: true},
      });
    }
  };

  return (
    <form className="w-full h-full px-3" onSubmit={handleSubmit}>
      <div className="flex items-center justify-between border-b border-gray-200 h-14">
        <span>ثبت آدرس</span>
        <i
          className="text-xl icon-nameClose-remove font-Bold"
          onClick={() => {
            if (stateAll?.store_guid) {
              navigate(
                `/edit-register-store/${stateAll?.type}/${stateAll.store_guid}`,
                {
                  state: {tab: 3},
                },
              );
            } else if (stateAll?.lab_guid) {
              navigate(
                `/edit-register-store/${stateAll?.type}/${stateAll.lab_guid}`,
                {
                  state: {tab: 4},
                },
              );
            } else if (state?.selectedInput?.id === 2) {
              navigate('/register-lab', {
                state: {tab: 4},
              });
            } else {
              navigate(
                `/register-store/${getStoreName(state.selectedInput?.code!)}`,
                {
                  state: {tab: 3},
                },
              );
            }
          }}
        />
      </div>
      <FloatingSearchBox
        label="جستجوی آدرس"
        type="text"
        value={inputValue}
        onChange={onChangeHandler}
        {...{inputValue, setInputValue}}
      />
      <div
        className="mt-4 overflow-y-auto rounded"
        style={{height: `calc(100% - 245px)`}}
      >
        <LocationalCustomMap
          location={selectLocation?.location}
          {...{latlng, setLatLng}}
        />
      </div>
      <button
        className={cn('text-white rounded w-full mt-4  py-3', {
          'bg-farm-shop-300': isLoading || !inputValue,
          'bg-farm-shop-500': !isLoading && inputValue,
        })}
        type="submit"
        disabled={isLoading || !inputValue}
      >
        ذخیره آدرس
      </button>
    </form>
  );
};

export default MyStoreAddLocationByMap;
